module.exports = __webpack_public_path__ + "static/VS_icon07-01-ddc505041eee72ea81d95f97df49cad7.png";